module.exports = __webpack_public_path__ + "media/images/icons/new_ultimas_leyes-bbc3decb9efb0703a59c8e1133fd2dc6.svg";